import { AfterViewInit, Component, ElementRef, Input, OnChanges, OnInit, ViewChild } from '@angular/core';

export class HorizontalFulfillmentGaugeData {
  header: string;
  value: number;
}

@Component({
    selector: 'horizontal-fulfillment-gauge',
    templateUrl: './horizontal-fulfillment-gauge.component.html',
    styleUrls: ['./horizontal-fulfillment-gauge.component.css'],
    standalone: false
})

export class HorizontalFulfillmentGaugeComponent implements OnInit, OnChanges, AfterViewInit {
  @ViewChild('progress', { static: false }) progress: ElementRef;
  @Input() data: HorizontalFulfillmentGaugeData;

  constructor() { }

  ngOnInit() {
  }

  ngOnChanges(): void {
    setTimeout(() => {
      this.setWidth();
    }, 100);
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.setWidth();
    }, 100);
  }

  private setWidth(): void {
    let item: HTMLCollection = this.progress.nativeElement;

    if (this.data.value > 0) {
      $(item).css('width', this.data.value + '%');
    }
  }
}
